const getPlaceHolder = (type) => {
  if (type === -1) {
    return '# 对于质量优秀的报告，会根据情况给予￥100-￥2000优质报告奖\n# 填写完善的报告将优先审核\n一、系统类型，MIUI系统版本号等\n二、测试APP版本号\n三、对应隐私问题类型，见右侧MiSRC隐私漏洞处理和评分规则，如3.8，以不正当方式误导用户同意收集个人信息\n四、问题描述 ，描述符合对应隐私问题类型的具体原因'
  }
  if (type === 49) {
    return '# 对于质量优秀的报告，会根据情况给予￥100-￥2000优质报告奖\n# 填写完善的报告将优先审核\n一、情报类型：简要分析情报所涉及的主要问题，如 漏洞、数据泄露、刷关注、刷单等\n二、攻击路径：受攻击的具体页面或接口，如 活动页面，被利用接口\n三、攻击方法：提供情报涉及的作弊或攻击所使用的技术手段、流程步骤或工具等'
  }
  if (type === 50 || type === 51) {
    return '# 对于质量优秀的报告，会根据情况给予￥100-￥2000优质报告奖\n# 填写完善的报告将优先审核\n一、受影响URL/APP/业务（详细的漏洞描述，漏洞涉及的url、漏洞参数等）\n二、漏洞证明 （漏洞影响说明以及漏洞利用证明）\n三、修复方案（针对报告的漏洞，提供一条及以上可执行的修复建议'
  }
  if (type === 52 || type === 53) {
    return '# 对于质量优秀的报告，会根据情况给予￥100-￥2000优质报告奖\n# 填写完善的报告将优先审核\n一、 测试机型、MIUI 系统版本以及安全补丁日期\n二、漏洞涉及APP的包名，版本号（请用应用商店升级最新版测试）\n三、漏洞分析的详细报告，包括必要的调用链描述+截图\n四、验证漏洞的poc，或exp 的源码+apk\n注：存在多交互场景或者具备一定演示效果的，请上传录制视频'
  }
  if (type === 54) {
    return '# 对于质量优秀的报告，会根据情况给予￥100-￥2000优质报告奖\n# 填写完善的报告将优先审核\n一、测试设备名称及固件版本\n二、漏洞分析的详细报告，包括必要的调用链描述+截图\n三、验证漏洞的poc，或exp 的源码\n注：若存在多交互场景或者具备一定演示效果的，请上传录制视频'
  }
  return '漏洞详情'
}

export default getPlaceHolder
